<template>
  <div class="template" v-if="isValidPage">
    <a-button class="button" type="primary" :loading="loading" @click="handleLogin">
      Continuar
    </a-button>
  </div>

  <h1 v-else>No user credentials</h1>
</template>

<script>
import { defineComponent } from "vue";
import { loadFacebook } from "@/app/shared/utils/loadFacebook";
import { tokenManager } from "@/app/shared/utils/tokenManager";
import httpManager from "@/app/shared/utils/httpManager";

import { ErrorTypes } from "@/app/channels/utils/enums";

export default defineComponent({
  beforeCreate() {
    loadFacebook();
  },
  data() {
    return {
      workspace: "",
      accessToken: null,
      channelId: null,
      loading: false,
    };
  },
  computed: {
    isValidPage() {
      return this.accessToken && this.workspace && this.channelId;
    },
    tenantUrl() {
      return `https://${this.workspace}.${import.meta.env.VITE_HOSTNAME}`;
    },
  },
  mounted() {
    this.accessToken = this.$route.query.access_token;
    this.workspace = this.$route.query.workspace;
    this.channelId = Number(this.$route.query.channelId);

    tokenManager.saveToken(this.accessToken);
    httpManager.updateBaseURL(`https://${this.workspace}.backend.${import.meta.env.VITE_HOSTNAME}`);

    if (!this.isValidPage) window.parent.postMessage("unknownError", this.tenantUrl);
  },
  methods: {
    async handleLogin() {
      try {
        this.loading = true;
        await this.$store.dispatch("deleteInstagramPage", this.channelId);
        window.parent.postMessage("successDelete", this.tenantUrl);
      } catch (error) {
        const errorMessage = error?.message || "Algo salió mal, por favor vuelve a intentarlo";

        console.log("deleteInstagramPage", { errorMessage });

        if (Number(errorMessage) === ErrorTypes.NotMarchingFbUser) {
          window.parent.postMessage("igUserIdNotMatching", this.tenantUrl);
        }

        window.parent.postMessage("unknownError", this.tenantUrl);

        console.log(errorMessage);
        this.loading = false;
      }
    },
  },
});
</script>

<style lang="sass" scoped>
.template
  height: 100vh
  width: 100vw
  display: grid
  place-content: center

.button
  width: 100vw
</style>
